<template>
  <div class="list leaderboard-page">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外教招聘</Breadcrumb-item>
        <Breadcrumb-item>招聘龙虎榜</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="page-head">
      <h2 class="page-title">外教招聘龙虎榜</h2>
      <span class="page-badge"><Icon type="trophy"></Icon> 招聘绩效</span>
    </div>
    <div class="search">
      <div class="lb-toolbar">
        <span class="toolbar-label">时间</span>
        <Select v-model="period" transfer style="width: 88px" :disabled="loading" @on-change="onPeriodChange">
          <Option v-for="item in periodOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <DatePicker v-if="period === 'day' || period === 'week'" type="date" format="yyyy-MM-dd" :value="anchorDate"
          :clearable="false" transfer style="width: 150px; margin-left: 8px" :disabled="loading"
          :title="period === 'week' ? '选择该周内任意一天，自动对齐到周一' : ''"
          @on-change="onDateChange"></DatePicker>
        <DatePicker v-if="period === 'month'" type="month" format="yyyy-MM" :value="anchorDate"
          :clearable="false" transfer style="width: 150px; margin-left: 8px" :disabled="loading"
          @on-change="onDateChange"></DatePicker>
        <DatePicker v-if="period === 'year'" type="year" format="yyyy" :value="anchorDate"
          :clearable="false" transfer style="width: 150px; margin-left: 8px" :disabled="loading"
          @on-change="onDateChange"></DatePicker>
        <span class="toolbar-range" v-if="rangeText">{{ rangeText }}</span>
        <span class="toolbar-label" style="margin-left: 16px">HR</span>
        <Select v-model="hr" placeholder="全部" clearable transfer style="width: 140px" :disabled="loading" @on-change="search">
          <Option v-for="item in hrOptions" :value="item.code" :key="item.code">{{ item.text }}</Option>
        </Select>
        <Button type="primary" style="margin-left: 12px" :loading="loading" @click="search">查询</Button>
      </div>
    </div>
    <div class="table-container">
      <p class="table-tip">按开课数倒序；新外教60天内离职量 ÷ 开课数 ≥ 15% 的行标红</p>
      <Table border :columns="columns" :data="tableRows" :loading="loading" :row-class-name="rowClassName"
        no-data-text="暂无数据"></Table>
    </div>
  </div>
</template>
<script>
const HIGH_CHURN = 0.15
/** 龙虎榜不展示的 HR，与后端 LEADERBOARD_EXCLUDED_HR 一致；不改全局 hrList */
const LEADERBOARD_EXCLUDED_HR = 'Amanda'

const NUM_COLUMNS = [
  {title: '开课数', key: 'classesStarted', strong: true},
  {title: '邀约数', key: 'invitations'},
  {title: '面试数', key: 'interviews'},
  {title: '发offer数', key: 'offersSent'},
  {title: '接offer数', key: 'offersAccepted'},
  {title: '培训中数', key: 'inTraining'},
  {title: '新外教60天内离职量', key: 'churn60d', churn: true},
  {title: '渠道开发数', key: 'channelDev'}
]

function churnRate (row) {
  let opened = Number(row.classesStarted) || 0
  if (opened <= 0) {
    return 0
  }
  return (Number(row.churn60d) || 0) / opened
}

export default {
  name: 'TchRecruitLeaderboard',
  data () {
    return {
      periodOptions: [
        {value: 'day', label: '日'},
        {value: 'week', label: '周'},
        {value: 'month', label: '月'},
        {value: 'year', label: '年'}
      ],
      period: 'month',
      anchor: this.$moment().format('YYYY-MM-DD'),
      hr: '',
      loading: false,
      result: {timeLabel: '', startDate: '', endDate: '', rows: []},
      appliedPeriod: 'month',
      appliedHr: '',
      reqId: 0,
      columns: []
    }
  },
  computed: {
    hrOptions () {
      return (this.$constant.hrList || []).filter(function (item) {
        return item && item.code !== LEADERBOARD_EXCLUDED_HR
      })
    },
    anchorDate () {
      return this.$moment(this.anchor, 'YYYY-MM-DD').toDate()
    },
    rangeText () {
      let r = this.result
      if (!r.startDate || !r.endDate) {
        return ''
      }
      return r.startDate === r.endDate ? r.startDate : r.startDate + ' ~ ' + r.endDate
    },
    tableRows () {
      let rows = (this.result.rows || []).filter(function (r) {
        return r && r.hr && r.hr !== LEADERBOARD_EXCLUDED_HR
      }).map((r) => this.normalizeRow(r))
      let exists = {}
      rows.forEach(function (r) {
        exists[r.hr] = true
      })
      let hrs = this.appliedHr ? [this.appliedHr] : this.hrOptions.map(function (item) {
        return item.code
      })
      hrs.forEach((code) => {
        if (!exists[code]) {
          rows.push(this.normalizeRow({hr: code}))
          exists[code] = true
        }
      })
      if (this.appliedHr) {
        rows = rows.filter((r) => r.hr === this.appliedHr)
      }
      rows = rows.map(function (r, i) {
        return {row: r, idx: i}
      }).sort(function (a, b) {
        let diff = b.row.classesStarted - a.row.classesStarted
        return diff !== 0 ? diff : a.idx - b.idx
      }).map(function (x) {
        return x.row
      })
      let label = this.result.timeLabel || ''
      return rows.map(function (r, i) {
        r.timeLabel = label
        r.rank = i
        return r
      })
    }
  },
  created () {
    this.columns = this.buildColumns()
    this.search()
  },
  methods: {
    normalizeRow (r) {
      let row = {hr: r.hr}
      NUM_COLUMNS.forEach(function (c) {
        row[c.key] = Number(r[c.key]) || 0
      })
      return row
    },
    buildColumns () {
      let columns = [
        {title: '时间', key: 'timeLabel', align: 'center', minWidth: 160},
        {
          title: 'HR',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let row = params.row
            let showTrophy = row.rank === 0 && this.appliedPeriod === 'month' && !this.appliedHr && row.classesStarted > 0
            return h('span', {class: 'hr-cell'}, [
              showTrophy ? h('Icon', {props: {type: 'trophy'}, class: 'trophy'}) : null,
              row.hr
            ])
          }
        }
      ]
      NUM_COLUMNS.forEach(function (c) {
        columns.push({
          title: c.title,
          key: c.key,
          align: 'center',
          minWidth: c.churn ? 150 : 100,
          render: function (h, params) {
            let row = params.row
            let cls = 'num-cell'
            if (c.strong) {
              cls += ' is-strong'
            }
            if (c.churn && churnRate(row) >= HIGH_CHURN) {
              cls += ' is-churn'
            }
            return h('span', {class: cls}, String(row[c.key]))
          }
        })
      })
      return columns
    },
    rowClassName (row) {
      return churnRate(row) >= HIGH_CHURN ? 'row-high-churn' : ''
    },
    onPeriodChange () {
      this.anchor = this.$moment().format('YYYY-MM-DD')
      this.search()
    },
    onDateChange (value) {
      if (!value) {
        return
      }
      if (this.period === 'month') {
        this.anchor = value + '-01'
      } else if (this.period === 'year') {
        this.anchor = value + '-01-01'
      } else {
        this.anchor = value
      }
      this.search()
    },
    queryDate () {
      let m = this.$moment(this.anchor, 'YYYY-MM-DD')
      if (this.period === 'week') {
        return m.startOf('isoWeek').format('YYYY-MM-DD')
      }
      if (this.period === 'month') {
        return m.startOf('month').format('YYYY-MM-DD')
      }
      if (this.period === 'year') {
        return m.startOf('year').format('YYYY-MM-DD')
      }
      return m.format('YYYY-MM-DD')
    },
    search () {
      let params = {period: this.period, date: this.queryDate()}
      if (this.hr) {
        params.hr = this.hr
      }
      let reqId = ++this.reqId
      let period = this.period
      let hr = this.hr || ''
      this.loading = true
      this.$http.post('/tchRecruit/leaderboard', params, {silent: true}).then((res) => {
        if (reqId !== this.reqId) {
          return
        }
        this.appliedPeriod = period
        this.appliedHr = hr
        if (res && res.status === 'ok') {
          let data = res.data || {}
          this.result = {
            timeLabel: data.timeLabel || '',
            startDate: data.startDate || '',
            endDate: data.endDate || '',
            rows: data.rows || []
          }
        } else {
          this.result = {timeLabel: '', startDate: '', endDate: '', rows: []}
          this.$Message.error((res && res.msg) || '龙虎榜加载失败')
        }
      }).catch(() => {}).finally(() => {
        if (reqId === this.reqId) {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.leaderboard-page { padding: 20px; }
.breadcrumb { margin-bottom: 16px; }
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-title { margin: 0; font-size: 20px; font-weight: 700; color: #1c2438; }
.page-badge { padding: 3px 10px; border-radius: 12px; background: #f0f2f5; font-size: 13px; color: #495060; }
.page-badge .ivu-icon { color: #2b6ef6; }
.search { margin-bottom: 16px; padding: 16px; border-radius: 4px; background: #f8f8f9; }
.lb-toolbar { display: flex; align-items: center; flex-wrap: wrap; }
.toolbar-label { margin-right: 8px; color: #495060; }
.toolbar-range { margin-left: 10px; font-size: 13px; color: #808695; }
.table-container { padding: 16px; border-radius: 4px; background: #fff; }
.table-tip { margin-bottom: 8px; font-size: 12px; color: #808695; }
.leaderboard-page /deep/ .ivu-table .row-high-churn td { background: #fff1f0; }
.leaderboard-page /deep/ .ivu-table-row-hover.row-high-churn td { background: #ffe7e3; }
.leaderboard-page /deep/ .num-cell { font-size: 14px; }
.leaderboard-page /deep/ .num-cell.is-strong { font-weight: 700; color: #2b6ef6; }
.leaderboard-page /deep/ .num-cell.is-churn { font-weight: 600; color: #ed3f14; }
.leaderboard-page /deep/ .hr-cell { font-weight: 600; }
.leaderboard-page /deep/ .trophy { margin-right: 6px; font-size: 16px; color: #f5a623; }
</style>



// WEBPACK FOOTER //
// TchRecruitLeaderboard.vue?6120fd2a